import { getCanvasSnapPoints, findNearestSnapPoint } from '../snapping';
import { rulerMarkSnap } from '../snapping/strategies';
import { getRulerMarkIntervals, getSnapSettings } from './utils';
import { SNAP_THRESHOLD } from './constants';

// Helper function to find the nearest ruler mark
export const findNearestRulerMark = (
  position,
  rulerSnapThreshold = 5,
  rulerUnit
) => {
  // Find the nearest ruler mark based on intervals
  const markIntervals = getRulerMarkIntervals(rulerUnit);
  const result = rulerMarkSnap(position, rulerSnapThreshold, markIntervals);
  return result.snapped ? result.position : null;
};

// Helper function to find snap points for guidelines
export const findGuidelineSnapPoint = (
  position,
  orientation,
  excludeGuideline
) => {
  const snapSettings = getSnapSettings();
  const snapPoints = getCanvasSnapPoints(
    window.canvas,
    orientation,
    excludeGuideline,
    {
      threshold: SNAP_THRESHOLD,
      enableCenterSnapping: false, // Guidelines should not snap to object centers
      enableEdgeSnapping: snapSettings.enableEdgeSnapping,
      enableGuidelineSnapping: false, // Don't snap to other guidelines
    }
  );

  // Filter out snap points from objects that are at canvas center
  // This prevents guidelines from getting stuck on center-aligned objects
  const canvas = window.canvas;
  const canvasWidth = canvas.getWidth();
  const canvasHeight = canvas.getHeight();
  const canvasCenterX = canvasWidth / 2;
  const canvasCenterY = canvasHeight / 2;
  const centerThreshold = 5; // Objects within 5px of center are considered center-aligned

  const filteredSnapPoints = snapPoints.filter((snapPoint) => {
    if (!snapPoint.object || snapPoint.object.isGuideline) {
      return true; // Keep non-object snap points
    }

    const objCenter = snapPoint.object.getCenterPoint();
    const isAtCenterX =
      Math.abs(objCenter.x - canvasCenterX) <= centerThreshold;
    const isAtCenterY =
      Math.abs(objCenter.y - canvasCenterY) <= centerThreshold;

    // Exclude snap points from center-aligned objects
    if (orientation === 'horizontal' && isAtCenterY) {
      return false; // Don't snap horizontal guidelines to horizontally-centered objects
    }
    if (orientation === 'vertical' && isAtCenterX) {
      return false; // Don't snap vertical guidelines to vertically-centered objects
    }

    return true;
  });

  const nearestSnap = findNearestSnapPoint(
    position,
    filteredSnapPoints,
    SNAP_THRESHOLD
  );
  return {
    position: nearestSnap ? nearestSnap.position : null,
    info: nearestSnap,
  };
};
